import React from 'react';
import { useNavigate } from 'react-router-dom';
import BackIcon from "../Images/backIcon.png";
import HomeIcon from "../Images/homeIcon.png";
import './pageBreadcrumb.css';
import { Home } from 'lucide-react';

const PageBreadcrumb = ({
    children,
    homePath = '/dashboard',
    extraButtons,
    onBack,
    style,
    variant = 'button',
    backLabel = 'Back',
    homeLabel = 'Back to Home',
}) => {
    const navigate = useNavigate();

    const handleBack = () => {
        if (onBack) {
            onBack();
            return;
        }
        navigate(-1);
    };

    if (variant === 'button') {
        return (
            <div className="page-breadcrumb-wrapper" style={style}>
                <div className="px-10 flex justify-between items-center">

                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-1 bg-[#C21A17] text-white px-4 py-2 rounded-xl text-sm font-semibold shadow-md cursor-pointer"
                    >
                        <img src={BackIcon} alt="Back"
                            className="w-[15px] object-contain transition-transform duration-300 hover:scale-105" />
                        Back
                    </button>

                    <button
                        onClick={() => navigate("/admin")}
                        className="flex items-center gap-1 bg-[#C21A17] text-white px-4 py-2 rounded-xl text-sm font-semibold shadow-md cursor-pointer"
                    >
                        <img src={HomeIcon} alt="Home"
                            className="w-[15px] object-contain transition-transform duration-300 hover:scale-105" />
                        Home
                    </button>

                </div>

            </div>

        );
    }

    // return (
    //     <div className="page-breadcrumb-wrapper" style={style}>
    //         <div className="page-breadcrumb-row">
    //             <div className="page-breadcrumb-trail">
    //                 {children}
    //             </div>
    //             <div
    //                 className="page-breadcrumb-back-arrow"

    //             >
    //                 <button
    //                     className="breadcrumb-action-btn"
    //                     type="button"
    //                     onClick={handleBack}
    //                 >
    //                     <span className="back-arrow">↩</span>
    //                     <span>Back</span>
    //                 </button>
    //             </div>
    //             <div className="page-breadcrumb-actions">
    //                 {extraButtons}
    //                 <div
    //                     className="page-breadcrumb-home-icon"
    //                     onClick={() => navigate(homePath)}
    //                     title="Go Home"
    //                 >
    //                     <Home size={16} />
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    // );
};

export default PageBreadcrumb;
